import pythonApiClient from './pythonBaseApi';

/**
 * Servicio para gestión de tipos de servicio de comedor
 * Maneja todas las operaciones CRUD relacionadas con tipos de servicio de comedor
 */
export const tipoServicioComedorApi = {
  /**
   * Obtiene todos los tipos de servicio de comedor
   * @returns {Promise} - Respuesta de la API
   */
  getAll: () => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.get('/tipo-servicios-comedores');
  },

  /**
   * Obtiene un tipo de servicio de comedor por ID
   * @param {number} id - ID del tipo de servicio de comedor
   * @returns {Promise} - Respuesta de la API
   */
  getById: (id) => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.get(`/tipo-servicios-comedores/${id}`);
  },

  /**
   * Crea un nuevo tipo de servicio de comedor
   * @param {Object} data - Datos del tipo de servicio de comedor
   * @param {number} data.id_tipo_servicio_alimentacion - ID del tipo de servicio de alimentación
   * @param {number} data.id_comedor - ID del comedor
   * @param {number} data.estado - Estado del tipo de servicio (1=activo, 0=inactivo)
   * @returns {Promise} - Respuesta de la API
   */
  create: (data) => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.post('/tipo-servicios-comedores', data);
  },

  /**
   * Actualiza un tipo de servicio de comedor existente
   * @param {number} id - ID del tipo de servicio de comedor
   * @param {Object} data - Datos actualizados del tipo de servicio
   * @returns {Promise} - Respuesta de la API
   */
  update: (id, data) => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.put(`/tipo-servicios-comedores/${id}`, data);
  },

  /**
   * Elimina un tipo de servicio de comedor
   * @param {number} id - ID del tipo de servicio de comedor
   * @returns {Promise} - Respuesta de la API
   */
  delete: (id) => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.delete(`/tipo-servicios-comedores/${id}`);
  },

  /**
   * Obtiene tipos de servicios de comedor por proyecto
   * @param {number} proyectoId - ID del proyecto
   * @returns {Promise} - Respuesta de la API
   */
  getByProyecto: (proyectoId) => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.get(`/proyectos/${proyectoId}/tipos-servicios-comedor`);
  },

  /**
   * Obtiene tipos de servicios de comedor por comedor
   * @param {number} comedorId - ID del comedor
   * @returns {Promise} - Respuesta de la API
   */
  getByComedor: (comedorId) => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.get(`/comedores/${comedorId}/tipos-servicios-comedor`);
  }

};

export default tipoServicioComedorApi;
